export const IS_FLAGGED_COL_NAME = 'isFlagged'
export const PRIORITY_COL_NAME = 'priority'
export const BULK_ACTION_CHECKBOX_COL_ID = 'bulkActionCheckbox'
export const FACILITY_COL_NAME = 'facility'
export const FLOOR_COL_NAME = 'floorName'
export const DATE_COL_NAME = 'date'
export const DISPLAY_ID_COL_NAME = 'displayId'
export const INCIDENT_NAME_COL_NAME = 'incidentName'
export const STATUS_OWNER_COL_NAME = 'incidentStatusOwner'
export const OPERATOR_COL_NAME = 'operator'
export const GUARD_COL_NAME = 'guard'
